import React from "react"
import { Message } from 'semantic-ui-react';
import styled from 'styled-components';

const StyledErrorMessages = styled(Message)`
  width: 100%;

  &.ui.message>.close.icon {
    vertical-align: middle;
    top: auto;
  }
`;

interface DivWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  [key: string]: any
}

export class StyledErrorMessage extends React.Component<DivWrapperProps> {
  render() {
    const {children, warning, ...rest} = this.props;
    return <StyledErrorMessages color={!warning ? "red" : ""} warning={warning} {...rest}>
      {children}
    </StyledErrorMessages>;
  }
}

export default StyledErrorMessage;
